import { useQuery } from '@tanstack/react-query';

const fetchReports = async (unitId) => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/powerBIReport/list/${unitId}`);

    const response = await fetch(url.toString(), {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const data = await response.json();

    return data;
};

const usePowerBIReportGetWithPermissions = ({ unitId }) => {
    return useQuery(['powerBIReport/list', unitId], () => fetchReports(unitId), { enabled: !!unitId });
};

export default usePowerBIReportGetWithPermissions;
